import { fetchUserPermissions } from '../helpers/http';

/**
 * Есть ли доступ к редактированию билда этого проекта
 * @param project
 * @returns {boolean}
 */
const hasProjectWritePermission = function(project) {
  let writePermission = false;

  if (!project) {
    writePermission = fetchUserPermissions()['write_no_project'];
  } else {
    const projects = fetchUserPermissions()['write_projects'];
    writePermission = projects ? projects.includes(project.name) : false;
  }

  return writePermission;
};

/**
 * Есть ли доступ к редактированию билда любого проекта
 * @returns {boolean}
 */
const hasWritePermission = function() {
  let writeProject = fetchUserPermissions()['write_projects'];
  let writeNoProject = fetchUserPermissions()['write_no_project'];

  return Array.isArray(writeProject) && writeProject.length > 0 || writeNoProject;
};

const writeProjects = function() {
  return fetchUserPermissions()['write_projects'];
};

export {
  hasWritePermission,
  hasProjectWritePermission,
  writeProjects,
};